export default __webpack_public_path__ + "static/media/coins_black.ffa9bed0.svg";